import React from "react";
import { CalendarDays, Music, Coffee, Users } from "lucide-react";

const events = [
  {
    title: "Live Acoustic Night",
    date: "September 2, 2025",
    desc: "Unwind with soulful live music from local artists.",
    icon: <Music className="w-8 h-8 text-amber-600" />,
    image: "https://images.unsplash.com/photo-1506157786151-b8491531f063?auto=format&fit=crop&w=1600&q=80",
  },
  {
    title: "Coffee Brewing Workshop",
    date: "September 10, 2025",
    desc: "Learn the art of brewing the perfect cup from our expert baristas.",
    icon: <Coffee className="w-8 h-8 text-amber-600" />,
    image: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=1600&q=80",
  },
  {
    title: "Art & Latte Evening",
    date: "September 18, 2025",
    desc: "Sip on signature lattes while enjoying a curated art exhibition.",
    icon: <Users className="w-8 h-8 text-amber-600" />,
    image: "https://res.cloudinary.com/dri1qrcuu/image/upload/v1756041191/Art_Latte_Evening_odbrdx.jpg",
  },
];

const Events = () => {
  return (
    <main className="bg-neutral-50 text-gray-800">
      {/* Hero Section */}
      <section className="relative h-[50vh] bg-black flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=1600&q=80"
            alt="Events at Café"
            className="w-full h-full object-cover opacity-60"
          />
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Upcoming Events</h1>
          <p className="text-lg md:text-xl">
            Join us for nights of music, art, and coffee culture.
          </p>
        </div>
      </section>

      {/* Events Grid */}
      <section className="py-16 px-6 max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
        {events.map((event, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
          >
            <img
              src={event.image}
              alt={event.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <div className="flex items-center gap-3 mb-3">
                {event.icon}
                <h3 className="text-xl font-semibold">{event.title}</h3>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600 mb-3">
                <CalendarDays className="w-4 h-4 text-amber-600" />
                <span>{event.date}</span>
              </div>
              <p className="text-gray-700 text-sm">{event.desc}</p>
            </div>
          </div>
        ))}
      </section>

      {/* Call to Action */}
      <section className="py-16 px-6 text-center bg-neutral-100">
        <h2 className="text-3xl font-bold mb-4">Want to Host Your Own Event?</h2>
        <p className="text-gray-600 text-lg mb-6">
          We love collaborating with artists, musicians, and coffee lovers.  
          Reach out to us and let’s make it happen.
        </p>
        <a
          href="/contact"
          className="inline-block bg-amber-500 hover:bg-amber-600 text-white font-semibold px-6 py-3 rounded-full transition"
        >
          Contact Us
        </a>
      </section>
    </main>
  );
};

export default Events;
